import { ReactElement } from "react";

interface BulkFileChipProps {
  name: string;
  size: number;
  disabled?: boolean;
  onRemove: () => void;
}

const formatSize = (bytes: number): string =>
  bytes < 1024 * 1024
    ? `${Math.max(1, Math.round(bytes / 1024))} KB`
    : `${(bytes / (1024 * 1024)).toFixed(1)} MB`;

/**
 * The selected workbook. Only the file's own facts are shown — the contents
 * are the backend's to judge, via validate mode.
 */
const BulkFileChip: React.FC<BulkFileChipProps> = ({
  name,
  size,
  disabled = false,
  onRemove,
}): ReactElement => (
  <div className="file-chip">
    <div className="meta">
      <span className="badge">XLSX</span>
      <div>
        <p className="name" title={name}>
          {name}
        </p>
        <p className="sub">{formatSize(size)}</p>
      </div>
    </div>
    <button
      type="button"
      className="remove"
      disabled={disabled}
      onClick={onRemove}
    >
      Remove
    </button>
  </div>
);

export default BulkFileChip;
